import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
  useEffect,
  useContext,
} from 'react'
// eslint-disable-next-line import/no-named-as-default,import/no-named-as-default-member
import Portal from '../../helpers/portal'
import { AppContext } from '../../../utils/context'
import * as style from './modal.module.scss'
import useOutsideClickEvent from '../../../hooks/useOutsideClickEvent'

const Modal = forwardRef((props, ref) => {
  const [display, setDisplay] = useState(false)
  const [modalState, setModalState] = useContext(AppContext)
  const modalClickOutside = useRef(null)
  const clickOutside = useOutsideClickEvent(modalClickOutside)

  const handleClose = () => {
    setDisplay(false)
    setModalState(false)
  }

  const handleOpen = () => {
    setDisplay(true)
    setModalState(true)
  }

  useEffect(() => {
    if (!clickOutside) {
      handleClose()
    }
  }, [clickOutside])

  useImperativeHandle(ref, () => ({
    openModal: () => handleOpen(),
    closeModal: () => handleClose(),
  }))

  if (display) {
    return (
      <Portal>
        <div className={style.body}>
          <button type="button" onClick={handleClose} className={style.close}>
            ✕
          </button>
          <div ref={modalClickOutside} className={style.content}>
            {/* eslint-disable-next-line react/prop-types */}
            {props.children}
          </div>
        </div>
      </Portal>
    )
  }

  return null
})

export default Modal
